import { render, staticRenderFns } from "./RegistrationItemTable.vue?vue&type=template&id=d91111a0&"
import script from "./RegistrationItemTable.vue?vue&type=script&lang=ts&"
export * from "./RegistrationItemTable.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationItemTable.vue?vue&type=style&index=0&id=d91111a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports